<template>
  <el-card>
    <div class="table-panel flex flex-between">
      <div>
        <el-button
          class="mr10"
          type="primary"
          size="small"
          :disabled="value"
          @click="addBaseInfo"
        >新增基础信息</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="showAddHotBtn"
          @click="addHotList">
          增加分类排行榜单
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="addWaterMark">
          主图水印配置
        </el-button>
      </div>
      <!-- <div>
        <el-input
          clearable
          v-model.trim="keyWords"
          placeholder="属性类型"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div> -->
    </div>

    <div class="table text-center">
      <el-table
        @sort-change="sortChange"
        stripe
        ref="attrTable"
        :data="records"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          prop="textName"
          label="名称"
        ></el-table-column>
        <el-table-column header-align="center" align="center"  label="内容位置" >
          <template slot-scope="scope">
            <span class="status " v-if="scope.row.locationType === 'front'">前置</span>
            <span class="status " v-if="scope.row.locationType === 'end'">后置</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center"  label="是否展示" >
          <template slot-scope="scope">
            <span class="status success" v-if="scope.row.textType === 'master'">展示</span>
            <span class="status blue" v-if="scope.row.textType === 'slave'">不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
              <!-- <el-tooltip class="item" content="删除" placement="top">
                <button class="pointer mr10 no-bg" @click="remove(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </button>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
        title='主图水印配置'
        :visible.sync='addWaterMarkVisible'
        width='780px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='common-dialog'
      >
        <el-form ref="addWaterMarkForm" label-width="120px" :rules="rules" :model="waterMark">
      
          <el-form-item label="水印名称：" prop="textName">
            <el-input
              size="normal"
              placeholder="请输入水印名称"
              v-model="waterMark.textName"
            ></el-input>
          </el-form-item>
          <el-form-item label="水印图片" prop="waterTemplateImg">
              <div :class="[{'hiddenUpload': !!waterMark.waterTemplateImg}, 'flex']">
              <el-upload
                ref="eluploadMainPic"
                list-type="picture-card"
                :limit="1"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadWaterMarkPicSucc"
                :beforeUpload="beforeWaterMarkUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :on-remove="delWaterMarkPicSucc"
                :file-list="waterMark.fileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="center ml10">
                <div>图片尺寸建议750x750px（最多上传一张）</div>
                <div>图片大小为200KB以内</div>
              </div></div>
          </el-form-item>
          <el-form-item label="是否开启水印">
            <el-switch
              v-model="waterMark.isOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-form>
        <template slot='footer'>
          <el-button @click='handleAddWaterMark' type='primary' size='small'>确定</el-button>
          <el-button @click='addWaterMarkVisible = false' size='small'>取消</el-button>
        </template>
      </el-dialog>

      <el-dialog
        title='设置规则'
        :visible.sync='addHotDialogVisible'
        width='1300px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='common-dialog'
      >
        <el-form ref="addHotForm" label-width="120px" :rules="rules" :model="hotForm">
          <el-form-item label="榜单开关">
            <el-switch
              v-model="hotForm.isOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
          <div v-show="hotForm.isOpen">
            <el-form-item>
              <img class="hot-example" src="https://imgcdn.hemiao100.com/hemiaoBase/hmNewMall/hot-example.png" alt="">
            </el-form-item>
            <el-form-item label="背景图" prop="templateImg">
              <div :class="[{'hiddenUpload': !!hotForm.templateImg}, 'flex']">
              <el-upload
                ref="eluploadMainPic"
                list-type="picture-card"
                :limit="1"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :onProgress="uploading"
                :show-file-list="uploadShow"
                :on-remove="delMainPicSucc"
                :file-list="fileList"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="center ml10">
                <div>1.上传图片大小750*450，支持图片jpg/png格式</div>
                <div>2.不上传图片则显示默认背景色</div>
              </div></div>
            </el-form-item>
            <el-form-item label="关联分类类型" prop="categoryType">
              <el-radio v-model="hotForm.categoryType" label="offline">商品库分类</el-radio>
              <el-radio v-model="hotForm.categoryType" label="online">微店分类</el-radio>
            </el-form-item>
            <el-form-item label="活动规则说明" prop="gameRuleRemark">
              <div class="flex">
                <hm-rich-editor
                  v-model.trim="hotForm.gameRuleRemark"
                  :html="hotForm.gameRuleRemark"
                />
              </div>
            </el-form-item>
            <el-form-item label="分类配置" prop="mainList">
              <div class="config-wrap">
                <div class="config-item mb20" v-for="(item, index) in hotForm.mainList" :key="index">
                  <div class="label mr10">主推分类{{index + 1}}</div>
                  <el-input class="mr20" v-model.trim="item.title" placeholder="请输入标题" :maxlength="10" show-word-limit></el-input>
                  <!-- <el-select v-model="item.val" placeholder="选择微店分类">
                    <el-option v-for="val in 10" :key="val" :label="val"></el-option>
                  </el-select> -->
                  <el-cascader
                    v-show="hotForm.categoryType=='online'"
                    v-model="item.categoryRelModelList"
                    :show-message="isShowCategoryErr"
                    :show-all-levels="false"
                    size="small"
                    :props="wdCategoryFunc"
                    clearable
                  ></el-cascader>
                  <el-cascader
                    v-show="hotForm.categoryType=='offline'"
                    v-model="item.categoryRelModelList"
                    :show-message="isShowCategoryErr"
                    :show-all-levels="false"
                    size="small"
                    :props="productCategoryFunc"
                    clearable
                  ></el-cascader>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="热门分类" prop="tableList">
              <el-button @click="handleAddHotCategory" type="primary">添加热门分类</el-button>
              <div class="table-wrap">
                <el-table :data="hotForm.tableList" :header-cell-style="{background: '#DDDDDD',color: '#222222'}" size="small" border row-key="id">
                  <el-table-column label="标题" align="center">
                    <template slot-scope="scope">
                      <el-input v-model.trim="scope.row.title"  placeholder="请输入标题" :maxlength="10" show-word-limit ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="序号" align="center">
                    <template slot-scope="scope">
                      <el-input disabled v-model.trim="scope.row.number" placeholder="请输入"></el-input>
                    </template></el-table-column>
                  <el-table-column label="关联分类" align="center">
                    <template slot-scope="scope">
                      <!-- <el-select v-model="scope.row.categoryId" placeholder="选择分类">
                        <el-option v-for="item in 3" :key="item" :label="item" :value="item"></el-option>
                      </el-select> -->
                      <el-cascader
                        v-show="hotForm.categoryType=='online'"
                        v-model="scope.row.categoryRelModelList"
                        :show-message="isShowCategoryErr"
                        :show-all-levels="false"
                        size="small"
                        :props="wdCategoryFunc"
                        clearable
                      ></el-cascader>
                      <el-cascader
                        v-show="hotForm.categoryType=='offline'"
                        v-model="scope.row.categoryRelModelList"
                        :show-message="isShowCategoryErr"
                        :show-all-levels="false"
                        size="small"
                        :props="productCategoryFunc"
                        clearable
                      ></el-cascader>
                    </template>
                  </el-table-column>
                  <el-table-column label="背景图" align="center">
                    <template slot-scope="scope">
                      <!-- <el-select v-model="scope.row.categoryId" placeholder="选择分类">
                        <el-option v-for="item in 3" :key="item" :label="item" :value="item"></el-option>
                      </el-select> -->
                      <div :class="{'hiddenUpload': !!scope.row.templateImg}">
                        <el-upload
                          ref="eluploadMainPic"
                          list-type="picture-card"
                          :limit="1"
                          :data="{ fileDir: 'mall' }"
                          :headers="{ 'X-Access-Token': $token }"
                          :action="$uploadUrl"
                          :onSuccess="($event) => tableUploadMainPicSucc($event, scope)"
                          :on-remove="($event) => tableDelMainPicSucc($event, scope)"
                          :beforeUpload="beforeUpload"
                          :onProgress="uploading"
                          :show-file-list="uploadShow"
                          :file-list="scope.row.fileList"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <div @click="delHotCategory(scope)" class="pointer el-button--text"><span class="hmicon icon-shanchu"></span></div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>

        </el-form>
        <template slot='footer'>
          <el-button @click='handleAddHot' type='primary' size='small'>确定</el-button>
          <el-button @click='addHotDialogVisible = false' size='small'>取消</el-button>
        </template>
      </el-dialog>
  </el-card>
</template>

<script>
import HmSync from "@/components/HmIsSync";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie } from "@/utils/utils";
import HmRichEditor from "@/components/HmRichEditor";
import { getLoginUser } from "@/utils/auth";
export default {
  components: { HmSync, HmRichEditor },
  mixins: [outPutMixin],
  data() {
    const validateMainList = (rule, value, callback) => {
      for (let i of this.hotForm.mainList) {
        console.log(i);
        if(!i.categoryRelModelList[0] || !i.title) {
          callback(new Error("请完善分类配置"));
          break
        }
        if(i.categoryRelModelList.length) {
          const id = i.categoryRelModelList[i.categoryRelModelList.length - 1]
          const some = this.hotForm.mainList.some(item => item.categoryRelModelList[item.categoryRelModelList.length - 1] === id && item.number !== i.number)
          if(some) {
            callback(new Error("请不要设置重复的分类"));
            break
          }
        }
      }
      callback();
    };

    const validateTableList = (rule, value, callback) => {
      for (let i of this.hotForm.tableList) {
        if(!i.title || !i.number || !i.categoryRelModelList.length || !i.templateImg) {
            callback(new Error("请填写完整热门分类"));
            break
        }
        if(i.categoryRelModelList.length) {
          const id = i.categoryRelModelList[i.categoryRelModelList.length - 1]
          const some = this.hotForm.tableList.some(item => item.categoryRelModelList[item.categoryRelModelList.length - 1] === id && item.number !== i.number)
          if(some) {
            callback(new Error("请不要设置重复的分类"));
            break
          }
        }
      }

      callback();
    };
    return {
      keyWords: "",
      pageSize: 10,
      value: false,
      actName: "",
      isOutputing: false,
      currentPage: 1,
      sort: {},
      records: [],
      total: 0,
      addHotDialogVisible: false,
      addWaterMarkVisible: false,
      hotForm: {
        isOpen: false,
        categoryType: "offline",
        templateImg: "",
        gameRuleRemark: "",
        mainList: [
          {
            title: "",
            number: 1,
            categoryRelModelList: [],
          },
          {
            title: "",
            number: 2,
            categoryRelModelList: [],
          },
          {
            title: "",
            number: 3,
            categoryRelModelList: [],
          },
        ],
        tableList: [
          {
            id: 1,
            title: "",
            number: 1,
            categoryRelModelList: [],
          },
        ],
      },
      waterMark: {
        id:"",
        isOpen:false,
        textName:"",
        waterTemplateImg:"",
        fileList:[],
      },
      rules: {
        categoryType: [
          {
            required: true,
            message: "请选择关联分类类型",
            trigger: "blur",
          },
        ],
        waterTemplateImg: [
          {
            required: true,
            message: "请上传水印图片",
            trigger: "change",
          },
        ],
        templateImg: [
          {
            required: true,
            message: "请上传背景图",
            trigger: "change",
          },
        ],
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur",
          },
        ],
        mainList: [
          {
            required: true,
            trigger: "blur",
            validator: validateMainList,
          },
        ],
        tableList: [
          {
            required: true,
            trigger: "blur",
            validator: validateTableList,
          },
        ],
      },
      fileList: [],
      wdCategoryFunc: {
        multiple: false,
        // checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  // v.value = JSON.stringify({
                  //   wxshopCategoryId: v.wxshopCategoryId,
                  //   categoryName: v.categoryName,
                  // });
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId,
              })
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    // v.value = JSON.stringify({
                    //   wxshopCategoryId: v.wxshopCategoryId,
                    //   categoryName: v.categoryName,
                    // });
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  console.log("res.result", res.result);
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      productCategoryFunc: {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId,
              })
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      isShowCategoryErr: false,
      uploadShow: true,
      showAddHotBtn: true,
      hotFormId: "",
      storeCode: "",
    };
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.getModelByParamCode();
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    getModelByParamCode() {
      this.$store
        .dispatch("getModelByParamCode", {
          paramCode: "mp_goods_offline_cat_ranking_config",
        })
        .then((res) => {
          console.log("---getModelByParamCode---", res);
          const { code, result } = res;
          if (code === "0") {
            if (result === null) {
              this.showAddHotBtn = false;
            } else {
              this.hotFormId = result.id;
              this.showAddHotBtn = true;
              if (result.optionValues) {
                this.hotForm = JSON.parse(result.optionValues);
                this.fileList = this.hotForm.templateImg
                  ? [{ url: this.hotForm.templateImg }]
                  : [];
                this.hotForm.tableList.forEach((v, index) => {
                  v.fileList = v.templateImg
                  ? [{ url: v.templateImg }]
                  : [];
                })
                console.log("---hotForm--", this.hotForm);
              }
            }
          }
        });
    },
    toDetails(row) {
      this.$router.push({
        name: "AttrDetails",
        query: {
          id: row.typeId,
        },
      });
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addBaseInfo() {
      this.$router.push({
        name: "AddBaseInfo",
      });
    },
    edit(row) {
      this.$store.commit("SET_BASE_INFO", row);
      this.$router.push({
        name: "AddBaseInfo",
        query: {
          id: row.id,
        },
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop,
      };
      this.setParamsCookie();
      const { result } = await this.$store.dispatch(
        "queryGoodsBaseInfo",
        params
      );
      const { records, total } = result;
      this.records = records;
      this.total = total;
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop,
      };
      setCookie({
        key: "goodsBaseInfo",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "goodsBaseInfo", type: "session" });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.sort.order = prams.order;
        this.sort.prop = prams.prop;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("deleteAttribute", {
            typeId: row.typeId,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
      });
    },
    /**
     * @desc 显示热卖榜单弹窗
     */
    addHotList() {
      this.addHotDialogVisible = true;
    },
    /**
     * @desc 显示添加水印弹窗
     */
    addWaterMark(){
      this.addWaterMarkVisible = true;
      this.getWaterMarkByParam();
    },
    /**
     * @desc 获取水印信息
     */
    getWaterMarkByParam(){
      this.$store
        .dispatch("getModelAllowNullNoToken",{paramCode:"overall_goods_watermark_switch",storeCode: this.storeCode,})
        .then((res)=>{
          const { code, result } = res;
          if (code === "0") {
            if (result !== null) {
              if (result.optionValues) {
                this.waterMark.id = result.id;
                this.waterMark.isOpen = (result.paramValue === "1") ? true : false;
                this.waterMark.textName = result.paramRemark;
                this.waterMark.waterTemplateImg = result.optionValues;
                this.waterMark.fileList = result.optionValues
                  ? [{ url: result.optionValues }]
                  : [];
              }
            }
          }
      })
    },
    /**
     * @desc 添加热卖榜单
     */
    handleAddHot() {
      this.$refs.addHotForm.validate((valid) => {
        if (valid) {
          console.log("---hotForm---", this.hotForm);

          const { mainList , tableList } = this.hotForm
          for(let item of mainList) {
            let some = tableList.some(v => item.categoryRelModelList[item.categoryRelModelList.length - 1] === v.categoryRelModelList[v.categoryRelModelList.length - 1])
            if(some) {
              return this.$message.warning('主推分类和热门分类的关联类型不能重复')
            }
          }


          let params = JSON.stringify(this.hotForm);
          if (this.hotFormId) {
            this.$store
              .dispatch("editStoreSystemParamInfo", {
                paramCode: "mp_goods_offline_cat_ranking_config",
                paramValue: true,
                optionValues: params,
                id: this.hotFormId,
              })
              .then((res) => {
                console.log("--editStoreSystemParamInfo--", res);
                this.getModelByParamCode();
                this.addHotDialogVisible = false;
                this.$store.dispatch("procWxshopHotSalesGoodsJob", {
                  storeCode: this.storeCode,
                });
              });
          } else {
            this.$store
              .dispatch("addStoreSystemParamInfo", {
                paramCode: "mp_goods_offline_cat_ranking_config",
                paramValue: true,
                optionValues: params,
                configType: "store",
              })
              .then((res) => {
                console.log("--addStoreSystemParamInfo--", res);
                this.getModelByParamCode();
                this.addHotDialogVisible = false;
                this.$store.dispatch("procWxshopHotSalesGoodsJob", {
                  storeCode: this.storeCode,
                });
              });
          }
        }
      });

      // this.addHotDialogVisible = false;
    },
    handleAddWaterMark(){
      this.$refs.addWaterMarkForm.validate((valid) => {
        if(valid){
          this.$store
          .dispatch("editStoreSystemParamInfo",{
            id:this.waterMark.id,
            paramRemark: this.waterMark.textName,
            optionValues: this.waterMark.waterTemplateImg,
            paramValue: this.waterMark.isOpen ? "1":"2",
          }).then((res)=>{
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.addWaterMarkVisible = false;
            }
          })
        }
      })
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    beforeWaterMarkUpload(file){
      const isJPG = file.type === 'image/png';
        const isLt2M = file.size / 1024 < 200;

        if (!isJPG) {
          this.$message({
            message: "上传头像图片只能是 PNG 格式!",
            type: "warning",
          });
        }
        if (!isLt2M) {
          this.$message({
            message: "上传头像图片大小不能超过 200KB!",
            type: "warning",
          });
        }
        return isJPG && isLt2M;
    },
    handleRemove() {
      this.hotForm.templateImg = "";
    },

    // 正在上传
    uploading() {
      this.isSaving = true;
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning",
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.hotForm.templateImg = jsonData.result;
      }
    },
    uploadWaterMarkPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.waterMark.waterTemplateImg = jsonData.result;
        this.waterMark.fileList.push({url:jsonData.result});
      }
    },
    delMainPicSucc() {
      this.hotForm.templateImg = "";
    },
    delWaterMarkPicSucc() {
      this.waterMark.waterTemplateImg = "";
      this.waterMark.fileList = [];
    },
    tableUploadMainPicSucc(jsonData, scope) {
      console.log('---jsonData---', jsonData);
      if (jsonData.code === 0) {
        this.hotForm.templateImg = jsonData.result;
        const index = scope.$index
        // this.hotForm.tableList
        this.$set(this.hotForm.tableList[index], "templateImg", jsonData.result)
      }
    },
    tableDelMainPicSucc($event, scope) {
        const index = scope.$index
        this.$set(this.hotForm.tableList[index], "templateImg", '')
    },
    /**
     * @desc 添加
    */
    handleAddHotCategory() {
      if (this.hotForm.tableList && this.hotForm.tableList.length) {
        let item = this.hotForm.tableList[this.hotForm.tableList.length - 1]
        this.hotForm.tableList.push({
          title: "",
          number: item.number?parseInt(item.number) + 1 :1,
          categoryRelModelList: [],
          id: item.id? parseInt(item.id) + 1:1, 
        })
      } else {
        this.hotForm.tableList.push({
          title: "",
          number: 1,
          categoryRelModelList: [],
          id: 1,
        })
      }
    },
    delHotCategory(scope) {
      const {row , $index} = scope

      this.hotForm.tableList.splice($index, 1)
      this.hotForm.tableList.forEach((v, index) => {
        if(index > $index - 1) {
          v.number --
        }
        console.log(v.categoryRelModelList)
      })
      console.log('this.hotForm', this.hotForm)
    }
  },
};
</script>
<style scoped lang="scss">
.title {
  font-size: 22px;
  font-weight: bold;
}
.switch {
  margin-right: 40%;
}
.hot-example {
  width: 230px;
  height: 570px;
}
.table-wrap {
  // border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}
.config-wrap {
  .config-item {
    display: flex;
    .label {
      width: 65px;
      height: 44px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 44px;
    }
    /deep/ .el-input__inner {
      height: 44px;
      line-height: 44px;
    }
  }
}
</style>
<style lang="scss">
.common-dialog {
  .el-form-item__label {
    line-height: 44px;
  }
  .el-switch,
  .el-switch__label {
    height: 44px;
    line-height: 44px;
  }
  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .pointer {
    cursor: pointer;
  }
  .hiddenUpload {
    .el-upload--picture-card {
      display: none;
    }
  }
  .el-table {
    .el-input {
      width: 100%;
    }
  }
}
</style>
